import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/Header';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Statistiche from './pages/Statistiche';
import Estrazioni from './pages/Estrazioni';
import Ipotesi from './pages/Ipotesi';
import Giocate from './pages/Giocate';
import Alert from './pages/Alert';
import Generatore from './pages/Generatore';
import Admin from './pages/Admin';
import Profilo from './pages/Profilo';
import SistemiRidotti from './pages/SistemiRidotti';
import ConfrontoRuote from './pages/ConfrontoRuote';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && !user.is_admin) {
    return <Navigate to="/" />;
  }

  return (
    <div className="app-container">
      <Header />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  if (user) {
    return <Navigate to="/" />;
  }

  return children;
};

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />
          
          <Route path="/" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          
          <Route path="/statistiche" element={
            <PrivateRoute>
              <Statistiche />
            </PrivateRoute>
          } />
          
          <Route path="/estrazioni" element={
            <PrivateRoute>
              <Estrazioni />
            </PrivateRoute>
          } />
          
          <Route path="/generatore" element={
            <PrivateRoute>
              <Generatore />
            </PrivateRoute>
          } />
          
          <Route path="/ipotesi" element={
            <PrivateRoute>
              <Ipotesi />
            </PrivateRoute>
          } />
          
          <Route path="/giocate" element={
            <PrivateRoute>
              <Giocate />
            </PrivateRoute>
          } />

          <Route path="/alert" element={
            <PrivateRoute>
              <Alert />
            </PrivateRoute>
          } />

          <Route path="/sistemi-ridotti" element={
            <PrivateRoute>
              <SistemiRidotti />
            </PrivateRoute>
          } />

          <Route path="/confronto-ruote" element={
            <PrivateRoute>
              <ConfrontoRuote />
            </PrivateRoute>
          } />

          <Route path="/profilo" element={
            <PrivateRoute>
              <Profilo />
            </PrivateRoute>
          } />
          
          <Route path="/admin" element={
            <PrivateRoute adminOnly>
              <Admin />
            </PrivateRoute>
          } />
          
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
